export const environment = {
    raygunApiKey: '',
    production: true,
    version: '1.0.0-test',
    apiUrl: 'https://mm-portal-as-dev-ae--api.azurewebsites.net/api/v2',
    legacyApiUrl: ''
};
